@if (loading) {
  <div>Loading...</div>
}
@if (!loading) {
  <form [formGroup]="meetingForm" class="meeting-form" (ngSubmit)="onSubmit()">
    <app-dialog-header
      cdkDrag
      cdkDragRootElement=".cdk-overlay-pane"
      title="Edit Meeting Instance"
      (closeClicked)="onCancelClick()"
    >
    </app-dialog-header>

    <mat-dialog-content class="fullscreen-dialog">
      <div class="container">
        <!-- Description Field -->
        @if (!meetingForm.enabled) {
          <p>
            This meeting is {{ visit.visitStatus }} and can no longer be edited
          </p>
        }
        <div class="form-row">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Description</mat-label>
            <input
              matInput
              formControlName="description"
              placeholder="Enter meeting description"
            />
          </mat-form-field>
        </div>
        <!-- Visit Type -->
        <div class="form-row">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Visit Type</mat-label>
            <mat-select formControlName="visitTypeId">
              @for (visitType of visitTypes; track visitType) {
                <mat-option [value]="visitType.id">
                  {{ visitType.description }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Date and Time Fields -->
        <div class="form-row">
          <!-- Start Date -->
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Date</mat-label>
            <input
              matInput
              [matDatepicker]="startPicker"
              formControlName="startDate"
              [min]="minDate"
              aria-label="Start date"
              title="Start date"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
          <!-- Start Time -->
          <mat-form-field appearance="fill" class="form-field time-field">
            <mat-label>Start Time</mat-label>
            <input
              matInput
              type="time"
              formControlName="startTime"
              class="time-input"
              aria-label="Start time"
              title="Start time"
            />
          </mat-form-field>
          <!-- Duration -->
          <mat-form-field appearance="fill" class="form-field time-field">
            <mat-label>Duration (minutes)</mat-label>
            <input
              matInput
              type="number"
              formControlName="duration"
              min="1"
              class="duration-input"
              aria-label="Duration in minutes"
              title="Duration in minutes"
            />
          </mat-form-field>
        </div>
        <!-- Resource Selection -->
        <div class="form-row">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Resources</mat-label>
            <mat-chip-grid #chipGrid>
              @for (resourceEntry of selectedResources; track resourceEntry) {
                <mat-chip-row
                  [removable]="true"
                  (removed)="removeResource(resourceEntry)"
                  [ngClass]="{
                    'chip-available': resourceEntry.status === 'Available',
                    'chip-conflicts': resourceEntry.status === 'Conflicts',
                    'chip-error': resourceEntry.status === 'Error',
                    'chip-checking': resourceEntry.status === 'Checking'
                  }"
                  [matTooltip]="
                    resourceEntry.conflicts.length > 0
                      ? 'Conflicts: ' + resourceEntry.conflicts.join(', ')
                      : ''
                  "
                >
                  <!-- Add avatar image -->
                  @if (resourceEntry.resource.imageUrl) {
                    <img
                      [src]="resourceEntry.resource.imageUrl"
                      alt="{{ resourceEntry.resource.name }}"
                      class="avatar-image"
                    />
                  }
                  <div class="chip-content">
                    <span class="resource-name">{{
                      resourceEntry.resource.name
                    }}</span>
                    <div class="chip-status">
                      @if (resourceEntry.loading) {
                        <mat-spinner diameter="16"></mat-spinner>
                      }
                      @if (!resourceEntry.loading) {
                        <span>
                          {{
                            meetingForm.enabled
                              ? resourceEntry.status
                              : resourceEntry.ticket?.ticketStatus
                          }}
                        </span>
                      }
                    </div>
                  </div>
                  @if (meetingForm.enabled) {
                    <button matChipRemove aria-label="Remove resource">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  }
                </mat-chip-row>
              }
              <input
                #resourceInput
                placeholder="Add Resource..."
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="false"
                [matAutocomplete]="auto"
                formControlName="resourceCtrl"
                (matChipInputTokenEnd)="addResource($event)"
                aria-label="Add resource"
              />
            </mat-chip-grid>
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="selectedResource($event)"
            >
              @for (resource of filteredResources | async; track resource) {
                <mat-option [value]="resource">
                  {{ resource.name }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
      <span class="spacer"></span>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="!meetingForm.enabled"
      >
        Save
      </button>
    </mat-dialog-actions>
  </form>
}
